import type { AxiosError } from 'axios';
import axios from 'axios';
import config from 'config/config';

const customerLeaveSession = async ({
  sessionId,
  isMissedCall,
  agentUsername,
  reason,
  storeBaseUrl
}: {
  agentUsername: string;
  isMissedCall: boolean;
  reason?: string;
  sessionId?: string;
  storeBaseUrl: string;
}): Promise<string | undefined> => {
  const apiBaseUrl = config.expertApi.enabled ? `${config.expertApi.url}` : `${config.api.url}`;

  try {
    const { data } = await axios<{ data: string }>({
      data: {
        agentUsername,
        isMissedCall,
        reason,
        sessionId: sessionId,
        storeBaseUrl
      },
      method: 'post',
      url: `${apiBaseUrl}/api/v2/sessions/customer/leave-session`
    });
    console.log(`Customer leave session successfully`, { agentUsername, sessionId });
    return data.data;
  } catch (e) {
    console.warn(`Failed to leave session: ${(e as AxiosError).message}`);
  }
};
export default customerLeaveSession;
